import TriggerList from "./TriggerList";

export default TriggerList